<template>
  <div>
    <b-columns is-multiline>
      <b-column class="is-full">
        <fire-fighting
          :omit-fire-diamond="omitFireDiamond"
          :is-dense="isDense" />
      </b-column>
    </b-columns>
  </div>
</template>

<script>
import FireFighting from './FireFighting'

export default {
  components: {
    FireFighting,
  },
  props: {
    omitFireDiamond: {
      type: Boolean,
      default: false
    },
    isDense: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style>
</style>
